import { z } from "zod";

export const DisciplinaCopiaRequestSchema = z.object({
  idDisciplina: z.number().nullable().optional(),
  idProjeto: z.number().nullable().optional(),
  descricao: z.string().trim().min(1, "A descrição é obrigatória"),

  dataDisciplina: z.coerce.date().nullable().optional(),

  revisao: z.string().nullable().optional(),
  plantas: z.string().nullable().optional(),
});

export type DisciplinaCopiaRequestForm = z.infer<typeof DisciplinaCopiaRequestSchema>;

export const defaultDisciplinaCopiaForm: Partial<DisciplinaCopiaRequestForm> = {
  dataDisciplina: null,
  descricao: "",
  revisao: "",
  plantas: "",
  idDisciplina: null,
  idProjeto: null,
}
